import { render } from "./delete.vue?vue&type=template&id=135d70ba&scoped=true"
import script from "./delete.vue?vue&type=script&lang=js"
export * from "./delete.vue?vue&type=script&lang=js"

import "./delete.vue?vue&type=style&index=0&id=135d70ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-135d70ba"

export default script